import React, {useEffect, useState} from "react";
import Grid from "@material-ui/core/Grid";
import jwt from "jwt-decode"
import {BRDmeView} from "./components/DmeView";
import {BRHospiceView} from "./components/HospiceView";
import {useHistory} from "react-router-dom";
import {useDispatch} from "react-redux";
import {reportTypes} from "../../../constants/types/reportTypes";
import {endpoints} from "../../../constants/endpoints";
import {checkPaceHospice, checkTokenAvailability, getHospiceLogo} from "../../../common/utils/utils";
import {logout} from "../../../redux/actions";
import {getAllDmes, getAllHospices, getContractedDme, getContractedHospices} from "../../utils/helpers/dataGetter";import {makeStyles} from "@material-ui/core/styles";
import {captionBase64} from "../../../constants/inputs/values";

export const BRStyles = makeStyles((theme) => ({
    tdHeaderCell: {
        padding: 8,
        border: "1px solid black",
        background: "lightgray"
    },
    tdDataCell: {
        padding: 8,
        border: "1px solid black"
    }
}));


export const BusinessReview = ({}) => {

    const token = JSON.parse(localStorage.getItem("key"));
    const userData = jwt(token.accessToken).payload;
    const history = useHistory();
    const dispatch = useDispatch();
    const [dmeOptions, setDmeOptions] = useState([]);
    const [hospiceOptions, setHospiceOptions] = useState([]);
    const [selectedDme, setSelectedDme] = useState(-1);
    const [selectedHospice, setSelectedHospice] = useState(-1);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [reportType, setReportType] = useState(reportTypes.quarterly);
    const [reportData, setReportData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [orgB64LogoCode, setOrgB64LogoCode] = useState(captionBase64);

    useEffect(() => {
        if (selectedHospice.value !== undefined && userData.type === "DME") {
            getHospiceLogo(setOrgB64LogoCode, token, selectedHospice.value);
        }
        if(userData.type === "Hospice") {
            getHospiceLogo(setOrgB64LogoCode, token, userData.hospice_organization_id);
        }
    }, [selectedHospice, userData.hospice_organization_id]);

    const handleInput = (e) => {
        switch (e.name){
            case "selectDme":
                setSelectedDme(e);
                break;
            case "selectHospice":
                setSelectedHospice(e);
                break;
            case "reportType":
                setReportType(e.value)
                setReportData({});
                break;
            case "startDate":
                setStartDate(e.value);
                break;
            case "endDate":
                setEndDate(e.value);
                break;
            default:
                break;
        }
    }

    const getReport = async () => {
        setIsLoading(true);
        let promise = await fetch(endpoints.businessReviewReport, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'Authorization': 'Bearer ' + token.accessToken
            },
            body: JSON.stringify({
                hospice_id: userData.type === "Hospice" ? userData.hospice_organization_id : selectedHospice.value,
                dme_id: userData.type === "DME" ? userData.dme_organization_id : selectedDme.value,
                report_type: reportType,
                start_date : startDate,
            })
        })
        let response = await promise.json()
        setReportData(response.data);
        setIsLoading(false);
    }

    useEffect(() => {
        (async () => {
            const availableToken = await checkTokenAvailability();
            if (!availableToken) {
                dispatch(logout());
                history.push('/login');
            }
        })();
        if(userData.type === "Hospice") {
            getContractedDme(setDmeOptions,userData.hospice_organization_id);
        }
        if(userData.type === "DME") {
            if(userData.role_id === 6) {
                getAllHospices(setHospiceOptions);
            } else {
                getContractedHospices(setHospiceOptions, [userData.dme_organization_id]);
            }
        }

    },[])

    return (
        <Grid container justify={"center"} alignContent={"center"} alignItems={"center"} spacing={1}>
            {userData.type === "DME" && <BRDmeView reportType={reportType}
                                                       hospiceOptions={hospiceOptions}
                                                       handleInput={handleInput}
                                                       startDate={startDate}
                                                       endDate={endDate}
                                                       getReport={getReport}
                                                       tableData={reportData}
                                                       isLoading={isLoading}
                                                       selectedHospice={selectedHospice}
                                                       hospiceLogo={orgB64LogoCode}

            />}
            {userData.type === "Hospice" && <BRHospiceView reportType={reportType}
                                                       dmeOptions={dmeOptions}
                                                       handleInput={handleInput}
                                                       startDate={startDate}
                                                       endDate={endDate}
                                                       getReport={getReport}
                                                       tableData={reportData}
                                                       isLoading={isLoading}
                                                       selectedDme={selectedDme}
                                                           hospiceLogo={orgB64LogoCode}
                                        />}
        </Grid>
    )
}